import React from "react";
import {Delete, translate} from "admin-on-rest";
import CustomerDataList from "./CustomerDataList";
import CustomerCreateForm from "./CustomerCreateForm";

///////////////////// LIST ALL CUSTOMERS /////////////////////
export const CustomerList = props => <CustomerDataList {...props} />;

///////////////////// CREATE NEW CUSTOMER /////////////////////
export const CustomerCreate = props => <CustomerCreateForm {...props} />;

///////////////////// DELETE CUSTOMER /////////////////////

const CustomerDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.first_name} ${record.last_name}`}
  </span>
);

const CustomerDeleteTitle = translate(CustomerDeleteTitleBase);

export const CustomerDelete = props => (
  <Delete {...props} title={<CustomerDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Customers/index.js